import { render, staticRenderFns } from "./getLinkView.vue?vue&type=template&id=6017640f&scoped=true"
import script from "./getLinkView.vue?vue&type=script&lang=js"
export * from "./getLinkView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6017640f",
  null
  
)

export default component.exports